import { track } from 'lib/analytics/segment';

import { PremiumEventNames } from 'common/constants/analytics';

export const trackPremiumScreenViewed = (referredFeature: string) =>
  track(PremiumEventNames.PremiumScreenViewed, { referredFeature });
